// New Arrivals — mobile rows use CSS scroll snap (no JS needed)
if (!customElements.get('new-arrivals')) {
  customElements.define('new-arrivals', class extends HTMLElement {
    connectedCallback() {}
  });
}
